export default "__VITE_ASSET__b4d9ec6a__"